import {
    useMemo,
} from 'react'
import {
    useUserRoles,
} from 'app/Auth'
import {
    ActiveTab,
} from '../MainMenu.types'
import useMainMenuConfig from './useMainMenuConfig'

const useAllowedLinks = () => {
    const mainMenuConfig = useMainMenuConfig()

    const roles = useUserRoles()

    return useMemo((): ActiveTab[] => {
        return mainMenuConfig
            .reduce((acum, item) => {
                return [
                    ...acum,
                    {
                        ...item,
                        links: item.links.filter(({
                            auth,
                        }) => {
                            if (!auth) {
                                return true
                            }

                            return auth.some((role) => {
                                return roles.includes(role)
                            })
                        }),
                    },
                ]
            }, [])
            .filter(({
                links,
            }) => {
                return links.length > 0
            })
    }, [
        roles,
        mainMenuConfig,
    ])
}

export default useAllowedLinks
